module.exports = __webpack_public_path__ + "img/infibo-how-to-buy-a-license-en-1.2c13f11c.png";